import type { User } from '@/types/database/users';

type ResidentOption = {
  key: string;
  label: string;
  value: string;
};

export type Resident = User & {
  _id: string;
  householdNumbers: string | string[];
};

export const getResidentsByHouseholdNumber = (
  householdNumber: string | string[] | undefined,
  users: Resident[]
) => {
  if (householdNumber) {
    const residentOptions = users.reduce(
      (residentOptions: ResidentOption[], user) => {
        const isOptionExist = residentOptions.some(
          (userObj) => userObj.label === user.name
        );

        const isMatchedUser =
          user.householdNumbers[0] ===
            (Array.isArray(householdNumber)
              ? householdNumber.join('-')
              : householdNumber) && !isOptionExist;

        if (isMatchedUser) {
          residentOptions.push({
            key: user._id,
            label: user.name,
            value: user.name,
          });
        }
        return residentOptions;
      },
      []
    );

    return residentOptions;
  } else {
    return [];
  }
};
